import React, { useContext, useEffect, useState } from 'react';
import { getDateWithMonthName, getWeek } from '../../../utils/dateTimeUtil';
import moment from 'moment-jalaali';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setDate } from '../../../redux/Appointment/AppointmentAction';
// import MENU_ICON from '../../../assets/images/feather-menu.png';
// import Menu from '../Menu/Menu.jsx';
import LanguageContext from '../../../contexts/languageContext';
import { DropDownIcon } from '../../UI/Images/Icons';
import styles from './CalenderStyle';

import { useParams } from 'react-router';
import { CalendarInput } from '../../UI';
import useCheckAccess from '../../../hooks/useCheckAccess';

const Calendar = () => {
    const [date] = useState(null);
    const { lang } = useContext(LanguageContext);
    const selectedDate = useSelector((state) => state.appointment?.date?.selected);
    const week = useSelector((state) => state.appointment?.date?.week);
    const params = useParams();
    const [isDay, setIsDay] = useState(true);
    const { notEditDemographic } = useCheckAccess();
    useEffect(() => {
        if (params.type === 'week') {
            setIsDay(false);
        } else {
            setIsDay(true);
        }
    }, [params]);
    const classes = styles({ rtl: lang === 'fa', noAccess: notEditDemographic });

    const dispatch = useDispatch();

    // const switchPanel = (type) => {
    //     if (type === 'appointment') {
    //         history.push('appointment');
    //     } else if (type === 'calendar') {
    //         history.push('calendar');
    //     } else if (type === 'patients') {
    //         history.push('patients');
    //     }
    //     setOpen(false);
    // };
    const handleChangeDate = (val) => {
        const dateVal = new Date(val);
        const selectedDate = moment(dateVal).format('YYYY-MM-DD');
        const prevDate = moment(date).format('YYYY-MM-DD');
        if (selectedDate !== prevDate) {
            dispatch(setDate(selectedDate));
        }
    };

    return (
        <div className={classes.patientHeaderCalender}>
            <div className={classes.menuContainer}></div>

            {selectedDate && (
                <div className={classes.datePickerContainer}>
                    <>
                        <div className={classes.dateContainer}>
                            <div className={classes.patientCalenderDateTextContainer}>
                                <div className={classes.patientCalenderDate}>
                                    {isDay ? (
                                        <>{getDateWithMonthName(selectedDate)}</>
                                    ) : (
                                        <>{getWeek(week[0], week[week.length - 1])}</>
                                    )}
                                </div>
                                <DropDownIcon width="24px" height="24px" fill={'black'} />
                            </div>
                        </div>

                        <div className={classes.calenderContainer}>
                            <CalendarInput
                                customClasses={classes.datePicker}
                                value={selectedDate}
                                setValue={handleChangeDate}
                                disabled={notEditDemographic}
                            />
                        </div>
                    </>
                </div>
            )}
        </div>
    );
};
Calendar.propTypes = {
    isDay: PropTypes.bool
};

export default Calendar;
